<template>
<div>

  <Row :gutter="10">
    <Col span="4"><search-city placeholder="Order City" v-model="clientCity"/></Col>
    <Col span="4"><search-city placeholder="Pickup City" v-model="pickupCity"/></Col>
    <Col span="4"><search-city placeholder="Drop City" v-model="dropCity"/></Col>

    <DatePicker v-model="filterDate" type="daterange" :options="dateOptions" placeholder="Select date" :clearable="false"
                format="dd/MM/yyyy" class="filterInput" style="width: 260px; float: right;margin-right: 10px"/>
  </Row>

  <Tabs v-model="tab" type="card" style="margin-top: 20px" @on-click="enableTab">
    <TabPane v-for="(s, index) in sArr" :key="index" :label="s.label + '('+$data[s.name+'Invoices'].length+')'" :name="s.name"/>
  </Tabs>

  <div v-for="(s, index) in sArr" :key="index" v-show="tab === s.name">
    <hot-table :settings="$data[s.name+'HotSettings']" :ref="s.name+'HotTableComponent'" style="margin: 20px 0 0 0">
      <hot-column v-for="(colset, idx) in getColumns(s.name)" :settings="colset" :key="idx"/>
    </hot-table>
  </div>

  <manage-order :orderId="orderId" ref="manage-order-page" :viewPath="viewPath"/>
  <charges-form :dialog.sync="chargesFormDialog" :clientInvoiceId.sync="clientInvoiceId" :pointTypeId="pointTypeId"/>
</div>
</template>

<script>
import { HotTable, HotColumn } from '@handsontable/vue';
import {generateHotSettings, roughtOfOrder, dateOptions} from "../../ExcelFormattedOrders/Settings";
import {dropCityChargesRenderer, orderCityChargesRenderer, orderDetailsRenderer,
  orderNumberRenderer, pickupCityChargesRenderer, statusRenderer} from "../RendererFunctions";
import {SUBSCRIBE_CLIENT_INVOICES_BY_ORDER_DATE} from "../../../graphql/subscription/clientInvoices";
import {Constants} from "../../../Constants/Constant";
import moment from 'moment';
import {totalChargesAmount} from "../Settings";
import ManageOrder from "../../Manage Order/ManageOrder";
import ChargesForm from "../ChargesForm";
import SearchCity from "../../Common/SearchCity";

let sArr = [
  {name: 'orderCity', status: null, label: 'Order City'},
  {name: 'pickupCity', status: null, label: 'Pickup City'},
  {name: 'dropCity', status: null, label: 'Drop City'}
];
let colWidths = [90, 100, 90, 120, 100, 145, 90, 115, 80, 90, 80];
export default {
  name: "CreateInvoiceTab",
  props:['globalSearch'],
  components: {SearchCity, ChargesForm, ManageOrder, HotTable, HotColumn},
  provide() {
    return {
      getManageOrderDrawer: () => this.manageOrderDrawer,
      setManageOrderDrawer: (data) => { this.manageOrderDrawer = data },
      getOrder: () => this.order,
      closeAssignVehicleDialog: (data) => { },
    }
  },
  apollo: {
    $subscribe: {
      clientInvoices: {
        query: SUBSCRIBE_CLIENT_INVOICES_BY_ORDER_DATE,
        fetchPolicy: 'network-only',
        variables() { return {
          startDate: moment(this.filterDate[0], 'DD/MM/YYYY').format('YYYY-MM-DDT00:00:00+05:30'),
          endDate: moment(this.filterDate[1], 'DD/MM/YYYY').format('YYYY-MM-DDT23:59:59+05:30'),
          status: [Constants.ClientInvoiceStatus.New],
          clientCity: {address: (this.clientCity?[{city: this.clientCity}]:[])},
          pickupCity: {address: (this.pickupCity?[{city: this.pickupCity}]:[])},
          dropCity: {address: (this.dropCity?[{city: this.dropCity}]:[])},
          search: '%' + this.globalSearch + '%',
          lrName: { lrName: this.globalSearch },
        }},
        result ({ data }) { this.prepareSheetData(data.clientInvoices) }
      }
    }
  },
  data(){
    return{
      Constants: Constants,
      moment: moment,
      tab: 'orderCity',
      sArr,
      ...sArr.reduce((ac, s) => {ac[s.name+'Invoices'] = []; ac[s.name+'HotSettings'] = generateHotSettings(colWidths); return ac}, {}),
      columns: (array) => [
        {title: 'Pickup<br> Date', data: 'pickupDate', type: 'date', dateFormat: 'DD MMM \'YY' },
        {title: 'Order No', data: 'orderNumber', renderer: (...args) => orderNumberRenderer(...args, this, array) },
        {title: 'Order<br> City', data: 'orderCity'},
        {title: 'Client Name', data: 'clientName'},
        {title: 'Route', data: 'route'},
        {title:'Status', data: 'internalStatusId', renderer: statusRenderer, exportKey: 'internalStatus'},
        {title: 'LR No', data: 'lr'},
        {title: 'Truck<br>Number', data: 'truckPlateNumber'},
        {title: 'Weight', data: 'kg', type: 'numeric'},
        {title: 'Order<br> Details', data: 'boxes', exportKey:'orderDetails', renderer: (...args) => orderDetailsRenderer(...args, this, array)}
      ],
      orderCityCol: {title: 'Order<br> City<br> Charges', data: 'orderCityCharges', renderer: (...args) => orderCityChargesRenderer(...args, this, 'orderCityInvoices')},
      pickupCityCol: {title: 'Pickup<br> City<br> Charges', data: 'pickupCityCharges', renderer: (...args) => pickupCityChargesRenderer(...args, this, 'pickupCityInvoices')},
      dropCityCol: {title: 'Drop<br> City<br> Charges', data: 'dropCityCharges', renderer: (...args) => dropCityChargesRenderer(...args, this, 'dropCityInvoices')},
      cities: JSON.parse(localStorage.cities).map(c => c.city),
      dateOptions,
      filterDate: [moment().subtract(7, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
      clientCity: '', pickupCity: '', dropCity: '',
      manageOrderDrawer: false,
      orderId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
      currentOrderStatus: '',
      order: '',
      viewPath: '',
      chargesFormDialog: false,
      clientInvoiceId: null,
      pointTypeId: null,
    }
  },
  methods:{
    enableTab() {},
    getColumns(name){
      return [...this.columns(name+'Invoices'), this[name+'Col']];
    },
    prepareSheetData(data) {
      let mainArr = {orderCity: [], pickupCity: [], dropCity: [],
                     orderCityInvoices: [], pickupCityInvoices: [], dropCityInvoices: []};
      data.forEach(curnt => {
        curnt.obj = {
          pickupDate: moment(curnt.Order.pickupDate, 'YYYY-MM-DD').format('DD/MM/YYYY'),
          orderNumber: curnt.Order.orderNumber,
          internalStatusId: curnt.Order.internalstatus,
          internalStatus: curnt.Order.internalStatus.name,
          orderCity: curnt.Order.clientobject.address[0].city,
          clientName: curnt.Order.clientobject.name,
          route: roughtOfOrder(curnt.Order),
          lr: curnt.Order.orderDetails.lrObject?.lrName||'',
          truckPlateNumber: curnt.Order.orderDetails.truckOrder?.truck.platNo||'-',
          kg: curnt.Order.materials.kg,
          boxes: curnt.Order.materials.boxes,
          orderCityCharges: curnt.orderCharges.aggregate.sum.amount,
          pickupCityCharges: curnt.pickupCharges.aggregate.sum.amount,
          dropCityCharges: curnt.dropCharges.aggregate.sum.amount,
         /* splOfferedFreight: curnt.Order.orderDetails.splOfferedFreight||0,
          clientInvoices_billingFreight: curnt.billingFreight,
          totalAmount: totalChargesAmount(curnt),
          action: '',
          orderDetails: curnt.Order.materials.type + ' (' + curnt.Order.materials.boxes + ')' */
        };
          /* Check specific point city falls in cityManager, if falls then push prepared object in hotSettings &
             main object in invoices array */
        if(this.cities.includes(curnt.obj.orderCity)) {mainArr.orderCity.push(curnt.obj); mainArr.orderCityInvoices.push(curnt)}
        if(this.cities.includes(curnt.obj.route.split('-')[0])) {mainArr.pickupCity.push(curnt.obj); mainArr.pickupCityInvoices.push(curnt)}
        if(this.cities.includes(curnt.obj.route.split('-')[1])){mainArr.dropCity.push(curnt.obj); mainArr.dropCityInvoices.push(curnt)}
      });
      sArr.forEach(s => {this[s.name+'Invoices'] = mainArr[s.name+'Invoices']; this[s.name+'HotSettings'].data = mainArr[s.name]})
    },
    openChargesForm(pointTypeId, clientInvoiceId){
      this.pointTypeId = pointTypeId;
      this.clientInvoiceId = clientInvoiceId;
      this.chargesFormDialog = true;
    },
    editOrder(order){
      this.orderId = order.id;
      this.viewPath = order.internalStatus.viewPath;      //Load form based on internalStatus.viewPath
      this.order = order;
      this.currentOrderStatus = order.internalStatus.id;
      this.manageOrderDrawer = true;
    },
  },
}
</script>

<style scoped>
  /deep/ .ivu-date-picker-cells  {
    font-size: 12px !important;
  }
  /deep/ .ivu-picker-panel-sidebar  {
    width:125px !important;
    margin-left:-116px !important;
  }
  /deep/ .handsontable > .ht_master{
    font-size: 14px;
  }
  /deep/ .handsontable > .ht_master > .wtHolder{
    width: unset !important;
    height: unset !important;
  }
  /deep/ .handsontable span.colHeader {
    font-size: 13px;
  }
  /deep/.handsontable td{
    vertical-align: middle !important;
    padding: 0 1px 0 1px !important;
    white-space: unset !important;
    font-size: 13px;
    color: #222;
  }

  /deep/.handsontable th{
    background-color: #d9d9d9;
    color: #222;
    text-align: center;
    font-weight: 600;
    vertical-align: middle !important;
    white-space: nowrap !important;
    padding: 0 0px 0 0px !important;
  }
</style>
<style>
  .underline-txt:hover {
    text-decoration: underline;
    cursor: pointer;
  }
  .charge-amount {
    text-decoration: underline;
    cursor: pointer;
  }
  .add-link{
    color: blue !important;
  }
  .action-btn{
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;
  }
  .green-txt{
    color: #85b86f !important;
  }
  .red-txt{
    color: red !important;
  }
  .include-query{
    color: red !important;
    background: #fce5cd !important;
    font-weight: 600;
  }
  .no-query{
    color: green !important;
    background: #d8ead3 !important;
    font-weight: 600;
  }
  .returned-invoice td{
    background: #f5e108 !important;
    color: #202020;
  }
</style>
<style src="../../../../node_modules/handsontable/dist/handsontable.full.css"></style>
